<div class="p-4 mt-8 dark:text-white">
  <h1
    class="text-2xl lg:text-4xl font-bold leading-tight tracking-tight md:text-2xl mb-8 md:mb-12"
  >
    Impressum
  </h1>

  <div class="flex flex-col gap-8">
    <div>
      <h2 class="text-xl font-semibold">Almanjobs UG (Haftungsbeschränkt)</h2>
      <div class="flex flex-col">
        <p>Wilbrandstraße 86</p>
        <p>33604 Bielefeld</p>
        <p>Deutschland</p>
      </div>
    </div>

    <div>
      <h2 class="text-xl font-semibold">Registereintrag</h2>
      <div class="flex flex-row gap-4">
        <div class="flex flex-col">
          <p>Eintragung in Registereintrag: </p>
          <p>Registernummer: </p>
        </div>
        <div class="flex flex-col">
          <p>Amtsgericht Bielefeld</p>
          <p>HRB 46019</p>
        </div>
      </div>
    </div>

    <div>
      <h2 class="text-xl font-semibold">Geschäftsführung</h2>
      <p>Houman Mahtabi</p>
    </div>

    <div>
      <h2 class="text-xl font-semibold">Kontakt</h2>
      <div class="flex flex-row gap-4">
        <div class="flex flex-col">
          <p>Telefon: </p>
          <p>E-Mail: </p>
        </div>
        <div class="flex flex-col">
          <p>+49 157 70885080</p>
          <p>houman.mahtabi&#64;almanjobs.com</p>
        </div>
      </div>
    </div>

    <div>
      <h2 class="text-xl font-semibold">Haftung für externe Links</h2>
      <p>Unsere Website enthält Links zu externen Webseiten, deren Inhalte außerhalb unseres Einflussbereichs liegen. Aus diesem Grund können wir keine Haftung für die Inhalte dieser externen Seiten übernehmen. Für die Inhalte der verlinkten Webseiten ist ausschließlich der jeweilige Anbieter oder Betreiber verantwortlich. Zum Zeitpunkt der Verlinkung wurden die externen Seiten sorgfältig auf mögliche Rechtsverstöße überprüft, wobei keine rechtswidrigen Inhalte erkennbar waren.
      Eine fortlaufende inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Hinweise auf eine Rechtsverletzung nicht zumutbar. Sollten uns solche Rechtsverletzungen bekannt werden, werden wir die entsprechenden Links unverzüglich entfernen.</p>
    </div>

    <div>
      <h2 class="text-xl font-semibold">Urheberrecht</h2>
      <p>Die auf Almanjobs-Seiten bereitgestellten Inhalte, unterliegen dem deutschen Urheberrecht. Jegliche Vervielfältigung, Bearbeitung, Verbreitung oder sonstige Verwertung außerhalb der Grenzen des Urheberrechts erfordert die vorherige schriftliche Zustimmung von Almanjobs. Downloads und Kopien dieser Seiten sind nicht gestattet.</p>
      <p>Sofern Inhalte auf dieser Seite nicht vom Betreiber selbst erstellt wurden, werden die Urheberrechte Dritter beachtet. Entsprechende Inhalte werden ausdrücklich als solche gekennzeichnet. Sollten Sie dennoch auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir Sie um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir die betroffenen Inhalte unverzüglich entfernen.</p>
    </div>

    <div>
      <h2 class="text-xl font-semibold">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
      <p>Almanjobs ist nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
    </div>
  </div>

</div>
